<div class="option-group">
  @if (showForm()) {
    <form (ngSubmit)="onSubmit()" #form="ngForm" [formGroup]="formGroup">
      @for (optionGroup of formOptions.controls; track optionGroup; let i = $index) {
        <div formArrayName="options" class="option-group__item">
          @switch (optionGroup.controls.type.value) {
            @case (ProductBundleOptionType.SELECT) {
              <app-speedy-select
                [label]="(optionGroup.value.title ?? optionGroup.value.default_title)!"
                placeholder="Choose an option"
                appearance="outline"
                name="option_selections"
                [fontSize]="14"
                [showCurrency]="true"
                [required]="!!optionGroup.controls.required.value"
                [control]="formOptions.controls[i].controls.option_selections.controls[0]"
                [options]="optionGroup.controls.product_links.value"
              ></app-speedy-select>
            }
            @case (ProductBundleOptionType.CHECKBOX) {
              <div class="items-wrapper" [formGroup]="formOptions.controls[i]">
                <label id="bundled-items-group-label">
                  {{ optionGroup.value.title ?? optionGroup.value.default_title }}
                  <span class="required">{{
                    !!optionGroup.value.required ? '*' : ''
                  }}</span>
                </label>
                <div class="items-wrapper__group">
                  @for (
                    option of optionGroup.controls.product_links.value;
                    track option;
                    let i = $index
                  ) {
                    <mat-checkbox
                      [formControl]="
                        optionGroup.controls.product_links.controls[i].controls.checked
                      "
                      class="items-wrapper__group-item"
                    >
                      {{ option.name }}<app-currency></app-currency>
                    </mat-checkbox>
                  }
                  @if (
                    formOptions.controls[i].controls.option_selections.controls[0].errors
                      ?.required &&
                    formOptions.controls[i].controls.option_selections.touched
                  ) {
                    <mat-error>
                      {{ 'This field is required' | translate | async }}
                    </mat-error>
                  }
                </div>
              </div>
            }
            @case (ProductBundleOptionType.RADIO) {
              <div class="items-wrapper">
                <label id="bundled-items-group-label">
                  {{ optionGroup.value.title ?? optionGroup.value.default_title }}
                  <span class="required">{{
                    !!optionGroup.value.required ? '*' : ''
                  }}</span>
                </label>
                <mat-radio-group
                  aria-labelledby="bundled-items-group-label"
                  class="items-wrapper__group"
                  [formControl]="
                    formOptions.controls[i].controls.option_selections.controls[0]
                  "
                >
                  @for (
                    option of optionGroup.controls.product_links.value;
                    track option
                  ) {
                    <mat-radio-button
                      class="radio-wrapper__group-item"
                      [value]="option?.id"
                    >
                      {{ option?.name }}<app-currency></app-currency>
                    </mat-radio-button>
                  }
                  @if (
                    formOptions.controls[i].controls.option_selections.controls[0].errors
                      ?.required &&
                    formOptions.controls[i].controls.option_selections.touched
                  ) {
                    <mat-error>
                      {{ 'This field is required' | translate | async }}
                    </mat-error>
                  }
                </mat-radio-group>
              </div>
            }
          }
          <app-speedy-input
            label="Qty"
            placeholder="Qty"
            name="option_qty"
            type="number"
            styles="text-align:center;"
            [fontSize]="14"
            [control]="formOptions.controls[i].controls.option_qty"
          ></app-speedy-input>
        </div>
      }
    </form>
  }
</div>
